export default __webpack_public_path__ + "static/Prediction-Blog-Image-2437ba4e10418236a511e9e569f321fd.png";